var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg26 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90.1 91",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "26")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M62.28,42.76v-2.1c0-8.53,0-17.07,0-25.6,0-1-.16-1.42-1.33-1.42q-22.57.07-45.14,0c-1.1,0-1.38.29-1.38,1.39q.05,30.49,0,61c0,1.14.35,1.36,1.41,1.36q22.57,0,45.14,0c1,0,1.46-.18,1.29-1.27-.72-4.68.72-8.79,3.39-12.57.63-.89,1.09-1.89,1.88-3.26,0,6.25.1,12,0,17.74-.06,2.68-1.83,4.26-4.5,4.59a16.86,16.86,0,0,1-2,.06H15.18a6,6,0,0,1-4.39-1.32,4.87,4.87,0,0,1-1.51-3.78q0-31.92,0-63.84c0-3.34,2-5.34,5.38-5.35q23.67,0,47.33,0c3.37,0,5.46,1.88,5.53,5.23.12,6.34,0,12.69,0,19a2.43,2.43,0,0,1-.27,1.12C65.73,36.61,64.13,39.46,62.28,42.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M53.18,72c0-2,0-3.74,0-5.53a3.14,3.14,0,0,1,.59-1.7Q62.61,49.53,71.41,34.3c.63-1.09,1.12-1.22,2.14-.49,1.22.87,3.38,1.34,3.64,2.36S76,38.74,75.2,40c-5.2,9-10.46,18-15.55,27-1.06,1.89-2.81,2.61-4.39,3.69C54.64,71.17,54,71.51,53.18,72Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M38.19,34.89c-5.84,0-11.68-.07-17.51,0-1.64,0-1.65-.7-1.56-1.87.08-1-.34-2,1.47-2q17.76.15,35.53,0c1.93,0,1.47,1,1.58,2.05.13,1.32-.16,1.81-1.66,1.79C50.09,34.83,44.14,34.89,38.19,34.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M38.34,48.6c5.94,0,11.88.06,17.82,0,1.52,0,1.62.63,1.52,1.76-.09,1,.42,2.06-1.43,2-11.94-.08-23.87-.06-35.81,0-1.2,0-1.36-.42-1.34-1.44,0-2.32,0-2.32,2.26-2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M33.82,25.8c-4.38,0-8.76-.07-13.13,0-1.39,0-1.76-.43-1.58-1.68a4.5,4.5,0,0,0,0-1.18c-.09-.75.22-.94.95-.94q13.72,0,27.44,0c.93,0,1.17.32,1.08,1.16a5,5,0,0,0,0,1.34c.17,1.07-.28,1.29-1.29,1.28C42.8,25.76,38.31,25.8,33.82,25.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M33.64,43.23c-4.37,0-8.74,0-13.11,0-1,0-1.47-.16-1.44-1.34.06-2.41,0-2.41,2.35-2.41,8.57,0,17.14.06,25.71,0,1.85,0,1.38,1,1.44,2s.09,1.85-1.5,1.81C42.6,43.14,38.12,43.23,33.64,43.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M33.84,56.88c4.48,0,9,0,13.44,0,1,0,1.33.28,1.32,1.31,0,2.44,0,2.44-2.33,2.44-8.57,0-17.14-.05-25.71,0-1.64,0-1.5-.78-1.45-1.82s-.4-2.07,1.45-2C25,57,29.41,56.88,33.84,56.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30.6,69.46a3.65,3.65,0,1,1,7.3.2,3.72,3.72,0,0,1-3.76,3.52A3.65,3.65,0,0,1,30.6,69.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.6,73.1a3.69,3.69,0,0,1-3.72-3.55A3.68,3.68,0,1,1,22.6,73.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M80.81,30.86c-.55.94-1.09,1.91-1.68,2.86-.26.41-.57.12-.85,0L76.1,32.44C73.55,31,73.45,30.29,75.4,28c.25-.29.4-.46.8-.23,1.39.82,2.8,1.61,4.2,2.42C80.64,30.33,80.87,30.48,80.81,30.86Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg26, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/26.c8610244.svg";
export { ForwardRef as ReactComponent };